// extracted by mini-css-extract-plugin
export default {"wrap":"V-z","heading":"W-z","formError":"X-z"};